// extracted by mini-css-extract-plugin
export default {"Loading":"styles_Loading__YBTni"};